import { DebugEvent } from 'core/DebugEvent';
import { ViewType } from 'app/data/Enums';

interface ViewReadyEventInterface {
	view: ViewType;
}

export class ViewReadyEvent extends DebugEvent implements ViewReadyEventInterface {
	public static eventName: string = 'VIEW_READY_EVENT';
	public view: ViewType;

	constructor(parameters: ViewReadyEventInterface) {
		super(parameters);
	}
}
